module.exports = __webpack_public_path__ + "static/media/1_Armada.94297790.jpg";